// extracted by mini-css-extract-plugin
export default {"root":"PaymentSelector_root__kdHsf"};